<template>
  <div
    v-if="hasErrors"
    class="alert alert-danger"
  >
    <div v-if="hasOneError">
      {{ errors[Object.keys(errors)[0]][0] }}
    </div>
    <div v-else>
      <b>{{ $t('lang.alerts.correct_errors') }}</b>
      <ul class="errors">
        <li
          v-for="(error, index) in errors"
          :key="index"
        >
          {{ errors[index][0] }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// @vuese
// Componente que muestra los errores de las peticiones
export default {
  name: 'Errors',

  // @vuese
  props: {
    errors: {
      type: Object,
      default: null,
    },
  },

  computed: {
    // @vuese
    hasErrors() {
      return Object.keys(this.errors).length > 0;
    },
    // @vuese
    hasOneError() {
      return Object.keys(this.errors).length === 1;
    },
  },
};
</script>

<style scoped>
</style>
